// Vue
import { ref } from "vue";

// Dependencies
import { defineStore } from "pinia";

// Types
import { ClassificationTypesType, ClassificationParametersType } from "../types/ClassificationTypesType";

// GraphQL
import { GetClassificationTypesQuery } from "@/graphql";

interface ClassificationTypesProvider {
  // Getters
  getClassificationTypes: () => ClassificationTypesType;

  // Methods
  mapData: (data: GetClassificationTypesQuery) => void;
  getClassificationParametersFromTypeId: (typeId: string) => ClassificationParametersType;

  // Utility
  getLoading: () => boolean;
  setLoading: (newValue: boolean) => void;
}

const useClassificationTypes = defineStore("ClassificationTypesProvider", (): ClassificationTypesProvider => {
  // ///////////////////
  // Refs
  // ///////////////////

  const classificationTypes = ref<ClassificationTypesType>([]);

  // ///////////////////
  // Getters
  // ///////////////////

  function getClassificationTypes() {
    return classificationTypes.value;
  }

  // ///////////////////
  // Setters
  // ///////////////////

  function setClassificationTypes(newModels: ClassificationTypesType) {
    classificationTypes.value = newModels;
  }

  // ///////////////////
  // Methods
  // ///////////////////

  function mapData(data: GetClassificationTypesQuery) {
    const { classificationCodeTypeCountry } = data;

    // Map all models
    if (!classificationCodeTypeCountry) return;
    setClassificationTypes(classificationCodeTypeCountry);
  }

  function getClassificationParametersFromTypeId(typeId: string): ClassificationParametersType {
    const classificationType = classificationTypes.value.find((type) => type.classificationType.id === typeId);
    return classificationType?.classificationType?.parameters || [];
  }

  // ///////////////////
  // Utility
  // ///////////////////

  const loading = ref<boolean>(false);

  function setLoading(newValue: boolean) {
    loading.value = newValue;
  }

  function getLoading() {
    return loading.value;
  }

  // ///////////////////
  // Returns
  // ///////////////////

  return {
    // Getters
    getClassificationTypes,

    // Methods
    mapData,
    getClassificationParametersFromTypeId,

    // Utility
    getLoading,
    setLoading,
  };
});

export default useClassificationTypes;
